export default class ToggleButton {
    constructor(elm, args) {
        const bodyClasslist = document.body.classList;
        const toggleButtons = document.querySelectorAll(
            '[data-component="toggle-button"]',
        );
        setTimeout(() => {
            elm.classList.remove('toggle-button--disable-animation');
        }, 40);

        if (bodyClasslist.contains('animate')) {
            bodyClasslist.remove('animate-in');
            bodyClasslist.remove('animate');
            window.history.pushState(
                {},
                document.title,
                this.removeURLParameter(
                    this.removeURLParameter(document.location.href, 'animate'),
                    'menu',
                ),
            );
        }

        const radios = elm.querySelectorAll('input');
        radios.forEach((radio) =>
            radio.addEventListener('change', () => {
                document.body.style.marginTop = '0';
                if (radio.id === 'b2c') {
                    document.cookie =
                        'moment_universe=jobseeker-theme;path=/;secure;SameSite=Strict';
                    toggleButtons.forEach((btn) => {
                        btn.classList.add('animate-left');
                        btn.classList.remove('animate-right');
                    });
                } else {
                    document.cookie =
                        'moment_universe=company-theme;secure;SameSite=Strict';
                    toggleButtons.forEach((btn) => {
                        btn.classList.add('animate-right');
                        btn.classList.remove('animate-left');
                    });
                }
                setTimeout(() => {
                    const openMenu = document.querySelector('.mobile-menu-open')
                        ? '?openMenu=true'
                        : '';
                    window.location.href = `${radio.dataset.url}${openMenu}`;
                }, 750);
            }),
        );
    }

    removeURLParameter(url, parameter) {
        // prefer to use l.search if you have a location/link object
        const urlparts = url.split('?');
        if (urlparts.length >= 2) {
            const prefix = encodeURIComponent(parameter) + '=';
            const pars = urlparts[1].split(/[&;]/g);

            // reverse iteration as may be destructive
            for (let i = pars.length; i-- > 0; ) {
                // idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }
            return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
    }
}
